/**
 * 현재 페이지 path에 매칭되는 활성 팝업 목록 조회.
 *
 * 영구지침: docs/develop/popup/popup-spec.md §9.1
 */
import { useQuery } from '@tanstack/react-query'
import { fetchActivePopups } from '@/features/popup/api'
import type { PopupResponse } from '@/features/popup/types'

export function useActivePopups(path: string) {
  return useQuery<PopupResponse[]>({
    queryKey: ['popups', path],
    queryFn: () => fetchActivePopups(path),
    staleTime: 60_000, // 1분
    refetchOnWindowFocus: false,
    retry: 0, // 팝업 조회 실패는 silent
  })
}
